var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-tag"},_vm._l((_vm.list),function(item,index){return _c('el-tag',{key:index,attrs:{"type":_vm.isHave(item),"size":"mini"}},[_vm._v(_vm._s(item.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }